import React from "react";
import Header from "../components/Header";
import Banner from "../components/Banner";
import Footer from "../components/Footer";
import ScrollToTopButton from "../components/ScrollTop";
import WhatsAppMsg from "../components/WhatsApp";

const BookDemo = () => {
  return (
    <>
      <div className="about-us-page">
        <Header />
      </div>
      <Banner
        imgSrc="https://content.qeeb.in/coltec/book-demo-banner.webp"
        altText="Want to Experience COLTEC Interactive Panels?"
        bannerHeight="md:h-[470px] h-[300px]"
        imgHeight="md:inset-auto pt-8 md:h-[470px] md:pt-0 h-[300px]"
        heading="Want to Experience COLTEC Interactive Panels?"
        headClasses="md:block text-center hidden max-w-2xl text-[21px] font-semibold tracking-tight leading-[1.7] text-white sm:text-4xl drop-shadow-lg mt-3"
        opacityClasses="opacity-layer absolute inset-0 w-full md:h-full h-[300px] bg-neutral-liner z-0"
        paragraphText="Connect with our experts today to explore our powerful and innovative interactive panels designed for modern classrooms and workplaces."
        positionClasses="absolute md:bottom-32 bottom-12 left-0 lg:inset-x-0 flex"
        headerTextClasses="text-[29px] md:text-4xl max-w-2xl text-white font-medium leading-10"
        paragraphTextClasses="md:text-base text-center md:block hidden text-sm text-white max-w-2xl mt-4"
      />
      <div className="md:hidden block px-6 py-8 bg-gray-50">
        <h2 className="w-[362px] relative justify-start text-black mb-4 text-xl font-medium font-['Poppins'] leading-tight">
          Want to Experience COLTEC Interactive Panels?
        </h2>
        <p className="max-w-[373px] relative justify-start text-black text-sm font-normal font-['Poppins'] leading-[19px]">
          Connect with our experts today to explore our powerful and innovative
          interactive panels designed for modern classrooms and workplaces.
        </p>
      </div>
      <div className="px-6 lg:px-8 md:pt-14 pt-8 pb-10 max-w-7xl m-auto book-demo-page">
        <div className="max-w-2xl mx-auto text-center mb-5 md:mb-8">
          <h2 className="relative flex justify-center text-black md:text-[30px] text-[24px] font-semibold font-['Poppins'] leading-[48px]">
            Request a Personalized Demo
          </h2>
          <p className="md:w-[680px] mx-auto text-center justify-start text-black text-xs leading-5 md:text-base font-normal font-['Poppins'] md:leading-[28px]">
            Fill in your details to discover how COLTEC Panels can transform
            collaboration, engagement, and productivity in your space!
          </p>
        </div>
        <iframe
          src="/bookdemo.html"
          title="outer-iframe"
          className="w-full lg:h-[430px] h-[700px] search-iframe"
          style={{ border: "none" }}
          allowFullScreen
        ></iframe>
        <p className="md:w-[700px] mx-auto text-center justify-start text-black text-xs leading-5 md:text-base font-normal font-['Poppins'] md:leading-[28px]">
          Our team will be in touch with you shortly to set up a demo
          based on your convenience any day of the week, Monday through Saturday
          9 am - 6 pm (IST)
        </p>
      </div>
      <Footer />
      <ScrollToTopButton />
      <WhatsAppMsg />
    </>
  );
};

export default BookDemo;
